module.exports = __webpack_public_path__ + "static/media/image2.45dfdae7.jpg";